import React from 'react';
import GrillType from '../../controls/grill/GrillType';
import GrillSize from '../../controls/grill/GrillSize';
import GrillPattern from '../../controls/grill/GrillPattern';
import HorizontalGrills from '../../controls/grill/HorizontalGrills';
import VerticalGrills from '../../controls/grill/VerticalGrills';

export const getGrillsTopSection = (props) => {
  const {
    isDisabled,
    topRowConfValue, 
    mainRowConfValue,
    windowTypeTopValue1,
    windowTypeTopValue2,
    windowTypeTopValue3,
    windowTypeTopValue4,
    windowTypeTopValue5,
    grillTypeTopValue1, setGrillTypeTopValue1,
    grillSizeTopValue1, setGrillSizeTopValue1,
    grillPatternTopValue1, setGrillPatternTopValue1,
    horizontalGrillsTopValue1, setHorizontalGrillsTopValue1,
    verticalGrillsTopValue1, setVerticalGrillsTopValue1,
    grillTypeTopValue2, setGrillTypeTopValue2,
    grillSizeTopValue2, setGrillSizeTopValue2,
    grillPatternTopValue2, setGrillPatternTopValue2,
    horizontalGrillsTopValue2, setHorizontalGrillsTopValue2,
    verticalGrillsTopValue2, setVerticalGrillsTopValue2,
    grillTypeTopValue3, setGrillTypeTopValue3,
    grillSizeTopValue3, setGrillSizeTopValue3,
    grillPatternTopValue3, setGrillPatternTopValue3,
    horizontalGrillsTopValue3, setHorizontalGrillsTopValue3,
    verticalGrillsTopValue3, setVerticalGrillsTopValue3,
    grillTypeTopValue4, setGrillTypeTopValue4,
    grillSizeTopValue4, setGrillSizeTopValue4,
    grillPatternTopValue4, setGrillPatternTopValue4,
    horizontalGrillsTopValue4, setHorizontalGrillsTopValue4,
    verticalGrillsTopValue4, setVerticalGrillsTopValue4,
    grillTypeTopValue5, setGrillTypeTopValue5,
    grillSizeTopValue5, setGrillSizeTopValue5,
    grillPatternTopValue5, setGrillPatternTopValue5,
    horizontalGrillsTopValue5, setHorizontalGrillsTopValue5,
    verticalGrillsTopValue5, setVerticalGrillsTopValue5,
  } = props;

  return [
    // Top Grills section starts ...
    (windowTypeTopValue1 !== "None") && (
    { id: "GrillTypeTop1",  component: 1 > mainRowConfValue ? null : ( <GrillType
      disabled={isDisabled} id = {"GrillTypeTop1"} label={"Grill Type 1"}
      value={grillTypeTopValue1}  onChange={(newValue) => { setGrillTypeTopValue1(newValue);}
    }/>),   position: [1, 1], status: "active", expandableSectionId: "GrillsTop" }),

    (windowTypeTopValue1 !== "None") && !['None'].includes(grillTypeTopValue1?.value) &&
    { id: "GrillSizeTop1",  component: 1 > mainRowConfValue ? null : ( <GrillSize
      disabled={isDisabled} id = {"GrillSizeTop1"} label={"Grill Size"}
      grillTypeValue={grillTypeTopValue1?.value}
      value={grillSizeTopValue1}  onChange={(newValue) => { setGrillSizeTopValue1(newValue);}
    }/>),   position: [1, 2], status: "active", expandableSectionId: "GrillsTop" },

    (windowTypeTopValue1 !== "None") && !['None'].includes(grillTypeTopValue1?.value) &&
    { id: "GrillPatternTop1",  component: 1 > mainRowConfValue ? null : ( <GrillPattern
      disabled={isDisabled} id = {"GrillPatternTop1"} label={"Grill Pattern"} hideOptions = {['Rays']}
      grillTypeValue={grillTypeTopValue1?.value}
      grillSizeValue={grillSizeTopValue1}
      value={grillPatternTopValue1}  onChange={(newValue) => { setGrillPatternTopValue1(newValue);}
    }/>),   position: [1, 3], status: "active", expandableSectionId: "GrillsTop" },

    (windowTypeTopValue1 !== "None") &&
    !['None'].includes(grillTypeTopValue1?.value) && ['Colonial', 'No Grills'].includes(grillPatternTopValue1?.value) &&
    { id: "HorizontalGrillsTop1",  component: 1 > mainRowConfValue ? null : ( <HorizontalGrills
      disabled={isDisabled} id = {"HorizontalGrillsTop1"} label={"Horizontal lines"}
      value={horizontalGrillsTopValue1}  onChange={(newValue) => { setHorizontalGrillsTopValue1(newValue);}
    }/>),   position: [2, 1], status: "active", expandableSectionId: "GrillsTop" },

    (windowTypeTopValue1 !== "None") &&
    !['None'].includes(grillTypeTopValue1?.value) && ['Colonial', 'No Grills'].includes(grillPatternTopValue1?.value) &&
    { id: "VerticalGrillsTop1",  component: 1 > mainRowConfValue ? null : ( <VerticalGrills
      disabled={isDisabled} id = {"VerticalGrillsTop1"} label={"Vertical lines"}
      value={verticalGrillsTopValue1}  onChange={(newValue) => { setVerticalGrillsTopValue1(newValue);}
    }/>),   position: [2, 2], status: "active", expandableSectionId: "GrillsTop" },

    (topRowConfValue !== "1") && (windowTypeTopValue2 !== "None") && (
    { id: "GrillTypeTop2",  component: 2 > mainRowConfValue ? null : ( <GrillType
      disabled={isDisabled} id = {"GrillTypeTop2"} label={"Grill Type 2"}
      value={grillTypeTopValue2}  onChange={(newValue) => { setGrillTypeTopValue2(newValue);}
    }/>),   position: [3, 1], status: "active", expandableSectionId: "GrillsTop" }),

    (topRowConfValue !== "1") && 
    (windowTypeTopValue2 !== "None") && !['None'].includes(grillTypeTopValue2?.value) &&
    { id: "GrillSizeTop2",  component: 2 > mainRowConfValue ? null : ( <GrillSize
      disabled={isDisabled} id = {"GrillSizeTop2"} label={"Grill Size"}
      grillTypeValue={grillTypeTopValue2?.value}
      value={grillSizeTopValue2}  onChange={(newValue) => { setGrillSizeTopValue2(newValue);}
    }/>),   position: [3, 2], status: "active", expandableSectionId: "GrillsTop" },

    (topRowConfValue !== "1") && 
    (windowTypeTopValue2 !== "None") && !['None'].includes(grillTypeTopValue2?.value) &&
    { id: "GrillPatternTop2",  component: 2 > mainRowConfValue ? null : ( <GrillPattern
      disabled={isDisabled} id = {"GrillPatternTop2"} label={"Grill Pattern"} hideOptions = {['Rays']}
      grillTypeValue={grillTypeTopValue2?.value}
      grillSizeValue={grillSizeTopValue2}
      value={grillPatternTopValue2}  onChange={(newValue) => { setGrillPatternTopValue2(newValue);}
    }/>),   position: [3, 3], status: "active", expandableSectionId: "GrillsTop" },

    (topRowConfValue !== "1") && 
    (windowTypeTopValue2 !== "None") &&
    !['None'].includes(grillTypeTopValue2?.value) && ['Colonial', 'No Grills'].includes(grillPatternTopValue2?.value) &&
    { id: "HorizontalGrillsTop2",  component: 2 > mainRowConfValue ? null : ( <HorizontalGrills
      disabled={isDisabled} id = {"HorizontalGrillsTop2"} label={"Horizontal lines"}
      value={horizontalGrillsTopValue2}  onChange={(newValue) => { setHorizontalGrillsTopValue2(newValue);}
    }/>),   position: [4, 1], status: "active", expandableSectionId: "GrillsTop" },

    (topRowConfValue !== "1") && 
    (windowTypeTopValue2 !== "None") &&
    !['None'].includes(grillTypeTopValue2?.value) && ['Colonial', 'No Grills'].includes(grillPatternTopValue2?.value) &&
    { id: "VerticalGrillsTop2",  component: 2 > mainRowConfValue ? null : ( <VerticalGrills
      disabled={isDisabled} id = {"VerticalGrillsTop2"} label={"Vertical lines"}
    value={verticalGrillsTopValue2}  onChange={(newValue) => { setVerticalGrillsTopValue2(newValue);}
    }/>),   position: [4, 2], status: "active", expandableSectionId: "GrillsTop" },

    (topRowConfValue !== "1") && 
    (windowTypeTopValue3 !== "None") && (
    { id: "GrillTypeTop3",  component: 3 > mainRowConfValue ? null : ( <GrillType
      disabled={isDisabled} id = {"GrillTypeTop3"} label={"Grill Type 3"}
      value={grillTypeTopValue3}  onChange={(newValue) => { setGrillTypeTopValue3(newValue);}
    }/>),   position: [5, 1], status: "active", expandableSectionId: "GrillsTop" }),

    (topRowConfValue !== "1") && 
    (windowTypeTopValue3 !== "None") && !['None'].includes(grillTypeTopValue3?.value) &&
    { id: "GrillSizeTop3",  component: 3 > mainRowConfValue ? null : ( <GrillSize
      disabled={isDisabled} id = {"GrillSizeTop3"} label={"Grill Size"}
      grillTypeValue={grillTypeTopValue3?.value}
      value={grillSizeTopValue3}  onChange={(newValue) => { setGrillSizeTopValue3(newValue);}
    }/>),   position: [5, 2], status: "active", expandableSectionId: "GrillsTop" },

    (topRowConfValue !== "1") && 
    (windowTypeTopValue3 !== "None") && !['None'].includes(grillTypeTopValue3?.value) &&
    { id: "GrillPatternTop3",  component: 3 > mainRowConfValue ? null : ( <GrillPattern
      disabled={isDisabled} id = {"GrillPatternTop3"} label={"Grill Pattern"} hideOptions = {['Rays']}
      grillTypeValue={grillTypeTopValue3?.value}
      grillSizeValue={grillSizeTopValue3}
      value={grillPatternTopValue3}  onChange={(newValue) => { setGrillPatternTopValue3(newValue);}
    }/>),   position: [5, 3], status: "active", expandableSectionId: "GrillsTop" },

    (topRowConfValue !== "1") && 
    (windowTypeTopValue3 !== "None") &&
    !['None'].includes(grillTypeTopValue3?.value) && ['Colonial', 'No Grills'].includes(grillPatternTopValue3?.value) &&
    { id: "HorizontalGrillsTop3",  component: 3 > mainRowConfValue ? null : ( <HorizontalGrills
      disabled={isDisabled} id = {"HorizontalGrillsTop3"} label={"Horizontal lines"}
      value={horizontalGrillsTopValue3}  onChange={(newValue) => { setHorizontalGrillsTopValue3(newValue);}
    }/>),   position: [6, 1], status: "active", expandableSectionId: "GrillsTop" },

    (topRowConfValue !== "1") && 
    (windowTypeTopValue3 !== "None") &&
    !['None'].includes(grillTypeTopValue3?.value) && ['Colonial', 'No Grills'].includes(grillPatternTopValue3?.value) &&
    { id: "VerticalGrillsTop3",  component: 3 > mainRowConfValue ? null : ( <VerticalGrills
      disabled={isDisabled} id = {"VerticalGrillsTop3"} label={"Vertical lines"}
    value={verticalGrillsTopValue3}  onChange={(newValue) => { setVerticalGrillsTopValue3(newValue);}
    }/>),   position: [6, 2], status: "active", expandableSectionId: "GrillsTop" },

    (topRowConfValue !== "1") && 
    (windowTypeTopValue4 !== "None") && (
    { id: "GrillTypeTop4",  component: 4 > mainRowConfValue ? null : ( <GrillType
      disabled={isDisabled} id = {"GrillTypeTop4"} label={"Grill Type 4"}
      value={grillTypeTopValue4}  onChange={(newValue) => { setGrillTypeTopValue4(newValue);}
    }/>),   position: [7, 1], status: "active", expandableSectionId: "GrillsTop" }),

    (topRowConfValue !== "1") && 
    (windowTypeTopValue4 !== "None") && !['None'].includes(grillTypeTopValue4?.value) &&
    { id: "GrillSizeTop4",  component: 4 > mainRowConfValue ? null : ( <GrillSize
      disabled={isDisabled} id = {"GrillSizeTop4"} label={"Grill Size"}
      grillTypeValue={grillTypeTopValue4?.value}
      value={grillSizeTopValue4}  onChange={(newValue) => { setGrillSizeTopValue4(newValue);}
    }/>),   position: [7, 2], status: "active", expandableSectionId: "GrillsTop" },

    (topRowConfValue !== "1") && 
    (windowTypeTopValue4 !== "None") && !['None'].includes(grillTypeTopValue4?.value) &&
    { id: "GrillPatternTop4",  component: 4 > mainRowConfValue ? null : ( <GrillPattern
      disabled={isDisabled} id = {"GrillPatternTop4"} label={"Grill Pattern"} hideOptions = {['Rays']}
      grillTypeValue={grillTypeTopValue4?.value}
      grillSizeValue={grillSizeTopValue4}
      value={grillPatternTopValue4}  onChange={(newValue) => { setGrillPatternTopValue4(newValue);}
    }/>),   position: [7, 3], status: "active", expandableSectionId: "GrillsTop" },

    (topRowConfValue !== "1") && 
    (windowTypeTopValue4 !== "None") &&
    !['None'].includes(grillTypeTopValue4?.value) && ['Colonial', 'No Grills'].includes(grillPatternTopValue4?.value) &&
    { id: "HorizontalGrillsTop4",  component: 4 > mainRowConfValue ? null : ( <HorizontalGrills
      disabled={isDisabled} id = {"HorizontalGrillsTop4"} label={"Horizontal lines"}
      value={horizontalGrillsTopValue4}  onChange={(newValue) => { setHorizontalGrillsTopValue4(newValue);}
    }/>),   position: [8, 1], status: "active", expandableSectionId: "GrillsTop" },

    (topRowConfValue !== "1") && 
    (windowTypeTopValue4 !== "None") &&
    !['None'].includes(grillTypeTopValue4?.value) && ['Colonial', 'No Grills'].includes(grillPatternTopValue4?.value) &&
    { id: "VerticalGrillsTop4",  component: 4 > mainRowConfValue ? null : ( <VerticalGrills
      disabled={isDisabled} id = {"VerticalGrillsTop4"} label={"Vertical lines"}
    value={verticalGrillsTopValue4}  onChange={(newValue) => { setVerticalGrillsTopValue4(newValue);}
    }/>),   position: [8, 2], status: "active", expandableSectionId: "GrillsTop" },

    (topRowConfValue !== "1") && 
    (windowTypeTopValue5 !== "None") && (
    { id: "GrillTypeTop5",  component: 5 > mainRowConfValue ? null : ( <GrillType
      disabled={isDisabled} id = {"GrillTypeTop5"} label={"Grill Type 5"}
      value={grillTypeTopValue5}  onChange={(newValue) => { setGrillTypeTopValue5(newValue);}
    }/>),   position: [9, 1], status: "active", expandableSectionId: "GrillsTop" }),

    (topRowConfValue !== "1") && 
    (windowTypeTopValue5 !== "None") && !['None'].includes(grillTypeTopValue5?.value) &&
    { id: "GrillSizeTop5",  component: 5 > mainRowConfValue ? null : ( <GrillSize
      disabled={isDisabled} id = {"GrillSizeTop5"} label={"Grill Size"}
      grillTypeValue={grillTypeTopValue5?.value}
      value={grillSizeTopValue5}  onChange={(newValue) => { setGrillSizeTopValue5(newValue);}
    }/>),   position: [9, 2], status: "active", expandableSectionId: "GrillsTop" },

    (topRowConfValue !== "1") && 
    (windowTypeTopValue5 !== "None") && !['None'].includes(grillTypeTopValue5?.value) &&
    { id: "GrillPatternTop5",  component: 5 > mainRowConfValue ? null : ( <GrillPattern
      disabled={isDisabled} id = {"GrillPatternTop5"} label={"Grill Pattern"} hideOptions = {['Rays']}
      grillTypeValue={grillTypeTopValue5?.value}
      grillSizeValue={grillSizeTopValue5}
      value={grillPatternTopValue5}  onChange={(newValue) => { setGrillPatternTopValue5(newValue);}
    }/>),   position: [9, 3], status: "active", expandableSectionId: "GrillsTop" },

    (topRowConfValue !== "1") && 
    (windowTypeTopValue5 !== "None") &&
    !['None'].includes(grillTypeTopValue5?.value) && ['Colonial', 'No Grills'].includes(grillPatternTopValue5?.value) &&
    { id: "HorizontalGrillsTop5",  component: 5 > mainRowConfValue ? null : ( <HorizontalGrills
      disabled={isDisabled} id = {"HorizontalGrillsTop5"} label={"Horizontal lines"}
      value={horizontalGrillsTopValue5}  onChange={(newValue) => { setHorizontalGrillsTopValue5(newValue);}
    }/>),   position: [10, 1], status: "active", expandableSectionId: "GrillsTop" },

    (topRowConfValue !== "1") && 
    (windowTypeTopValue5 !== "None") &&
    !['None'].includes(grillTypeTopValue5?.value) && ['Colonial', 'No Grills'].includes(grillPatternTopValue5?.value) &&
    { id: "VerticalGrillsTop5",  component: 5 > mainRowConfValue ? null : ( <VerticalGrills
      disabled={isDisabled} id = {"VerticalGrillsTop5"} label={"Vertical lines"}
    value={verticalGrillsTopValue5}  onChange={(newValue) => { setVerticalGrillsTopValue5(newValue);}
    }/>),   position: [10, 2], status: "active", expandableSectionId: "GrillsTop" },


    // Top Grills ends ...
  ];
};
